import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  HiOutlineArrowDownTray,
  HiOutlineDocumentArrowDown,
  HiOutlineInformationCircle,
} from "react-icons/hi2";

import { exportJongerenExcel } from "../../../redux/features/excelExport/excelExportSlice";
import { getSchoolYears } from "../../../redux/features/schoolYears/schoolYearSlice";

import "./JongerenExportPage.css";

const JongerenExportPage = () => {
  const dispatch = useDispatch();

  const [selectedSchoolYearId, setSelectedSchoolYearId] = useState("");

  const { loading, error } = useSelector((state) => state.excelExport);

  const { schoolYears } = useSelector((state) => state.schoolYears);

  useEffect(() => {
    dispatch(getSchoolYears());
  }, [dispatch]);

  useEffect(() => {
    if (!selectedSchoolYearId && schoolYears.length > 0) {
      const activeSchoolYear =
        schoolYears.find((year) => year.is_active) || schoolYears[0];

      setSelectedSchoolYearId(activeSchoolYear._id);
    }
  }, [schoolYears, selectedSchoolYearId]);

  const selectedSchoolYear = useMemo(() => {
    return schoolYears.find((year) => year._id === selectedSchoolYearId);
  }, [schoolYears, selectedSchoolYearId]);

  const handleExport = () => {
    if (!selectedSchoolYearId || loading) return;

    dispatch(exportJongerenExcel(selectedSchoolYearId));
  };

  return (
    <div className="jongeren-export-page">
      <section className="jongeren-export-page__hero">
        <div>
          <p className="jongeren-export-page__eyebrow">POWER Export</p>

          <h1>Jongeren exporteren</h1>

          <p>
            Download een Excel-bestand met alle dossiers van het gekozen
            schooljaar. Elke dossier wordt één rij. Als dezelfde jongere
            meerdere dossiers heeft, krijgt de naam automatisch een volgnummer
            zoals “Jongere (2)”.
          </p>
        </div>

        <div className="jongeren-export-page__hero-icon">
          <HiOutlineDocumentArrowDown />
        </div>
      </section>

      <section className="jongeren-export-page__card">
        <div className="jongeren-export-page__card-header">
          <div>
            <h2>Export instellingen</h2>
            <p>Kies het schooljaar waarvoor je de Excel wil downloaden.</p>
          </div>
        </div>

        <div className="jongeren-export-page__form">
          <label>
            <span>Schooljaar</span>

            <select
              value={selectedSchoolYearId}
              onChange={(event) => setSelectedSchoolYearId(event.target.value)}
              disabled={loading}
            >
              <option value="">Selecteer schooljaar</option>

              {schoolYears.map((schoolYear) => (
                <option key={schoolYear._id} value={schoolYear._id}>
                  {schoolYear.name || schoolYear.label || schoolYear.title}
                  {schoolYear.is_active ? " — actief" : ""}
                </option>
              ))}
            </select>
          </label>
        </div>

        {selectedSchoolYear && (
          <div className="jongeren-export-page__selected">
            <HiOutlineInformationCircle />

            <div>
              <strong>Geselecteerd schooljaar</strong>
              <span>
                {selectedSchoolYear.name ||
                  selectedSchoolYear.label ||
                  selectedSchoolYear.title}
              </span>
            </div>
          </div>
        )}

        {error && <div className="jongeren-export-page__error">{error}</div>}

        <div className="jongeren-export-page__actions">
          <button
            type="button"
            onClick={handleExport}
            disabled={!selectedSchoolYearId || loading}
            className="jongeren-export-page__button"
          >
            {loading ? (
              "Export wordt aangemaakt..."
            ) : (
              <>
                <HiOutlineArrowDownTray />
                Excel downloaden
              </>
            )}
          </button>
        </div>
      </section>

      <section className="jongeren-export-page__info-grid">
        <article>
          <h3>Wat staat er in de export?</h3>
          <p>
            Jongere, voornaam, familienaam, coach, coach e-mail, startdatum,
            organisatie, status, huidige stap en alle actieve veldconfiguraties.
          </p>
        </article>

        <article>
          <h3>Dubbele dossiers</h3>
          <p>
            Als één jongere meerdere dossiers heeft, wordt elk dossier apart
            geëxporteerd. De tweede rij krijgt “(2)” achter de naam.
          </p>
        </article>

        <article>
          <h3>Bestandsformaat</h3>
          <p>
            De export wordt gegenereerd als een nieuw Excel-bestand. Dit wijzigt
            niets in de database.
          </p>
        </article>
      </section>
    </div>
  );
};

export default JongerenExportPage;
